import {
  TextArea,
  type TextAreaHandle,
  type TextAreaProps,
} from '@progress/kendo-react-inputs'
import classNames from 'classnames'
import React from 'react'

import styles from './StyledTextArea.css'

export type StyledTextAreaProps = TextAreaProps & {
  'data-testid'?: string
  width?: '100%' | 'default'
  onValueChange?: (value: string) => void
}

export const StyledTextArea = React.forwardRef<
  TextAreaHandle,
  StyledTextAreaProps
>(
  (
    {
      className,
      'data-testid': dataTestId = 'components-elements-styled-text-area',
      onChange,
      onValueChange,
      width = 'default',
      ...rest
    },
    ref,
  ) => {
    const handleChange = React.useCallback<EH<TextAreaProps, 'onChange'>>(
      (event) => {
        onChange?.(event)
        onValueChange?.(event.value)
      },
      [onChange, onValueChange],
    )

    return (
      <TextArea
        ref={ref}
        autoComplete="off"
        className={classNames(styles.root, styles[`width-${width}`], className)}
        data-testid={dataTestId}
        onChange={handleChange}
        {...rest}
      />
    )
  },
)
